module.exports = __webpack_public_path__ + "images/ed33fd98ab0aecde9568f9f64969d8f8.svg";